/* eslint-disable no-useless-concat */

//set widget details in an object
export const setWidgetObj = (value) => {
	return { type: "SET_ADDWIDGET", payload: value };
};

//set no. of widgets added to list
export const setWidgetList = (value) => {
	return { type: "SET_WIDGET_LIST", payload: value };
};

//set no. of widgets added to list
export const setUpdateWidgetGraphType = (value, index, widgetList) => {
	let updateWidgetList = [...widgetList];
	updateWidgetList[index].graph_type = value;
	updateWidgetList[index].widget_name =
		value.charAt(0).toUpperCase() + value.slice(1) + " Chart";
	return { type: "SET_WIDGET_LIST", payload: updateWidgetList };
};

//If all selected checkbox is clicked
export const setAllSelectedCheckbox = (value) => {
	return { type: "SET_ALL_SELECTED_CHECKBOX", payload: value };
};

//If all selected checkbox is clicked
export const setIsSelected = (value) => {
	return { type: "SET_IS_SELECTED", payload: value };
};
//set chart type selected for a widget
export const setupdatedGraphData = (value) => {
	return { type: "SET_UPDATED_GRAPH_DATA", payload: value };
};
